import type { ReactNode } from "react";

interface QuizLayoutProps {
  progress: number;
  questionNumber?: number;
  questionCount: number;
  children: ReactNode;
}

export function QuizLayout({ progress, questionNumber, questionCount, children }: QuizLayoutProps) {
  const progressLabel = questionNumber ? `Pregunta ${questionNumber} de ${questionCount}` : "Tu diagnóstico";
  return (
    <div className="quiz-page">
      <header className="quiz-brand">
        <img src="/pasos-al-exito-logo.webp" alt="Pasos al Éxito 360" width="100" height="72" />
      </header>
      <main className="quiz-card" id="quiz-main">
        <p className="quiz-progress-label">{progressLabel}</p>
        <div
          className="quiz-progress"
          role="progressbar"
          aria-label="Progreso del cuestionario"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(progress)}
          aria-valuetext={progressLabel}
        >
          <span style={{ width: `${Math.round(progress)}%` }} />
        </div>
        {children}
      </main>
      <footer className="quiz-footer">
        <div className="footer-container footer-main">
          <div className="footer-col brand-col">
            <div className="footer-logo">
              <img src="/footer.png" alt="" width="125" />
            </div>
            <p className="brand-description">
              Alcanza tus metas personales y empresariales con entrenamientos estratégicos que aceleran tus resultados.
            </p>
            <div className="trustpilot-widget">
              <button type="button" data-local-disabled>
                <img src="/trustpilot-logo.png" alt="Opiniones de Pasos al Éxito en Trustpilot" />
              </button>
            </div>
          </div>

        </div>

        <div className="footer-middle">
          <div className="footer-container footer-middle-content">
            <div className="legal-links">
              <a href="https://www.pasosalexito.com/terminos-y-condiciones/" target="_blank" rel="noreferrer">Términos y condiciones</a>
              <a href="https://www.pasosalexito.com/politica-de-privacidad/" target="_blank" rel="noreferrer">Privacidad</a>
            </div>

          </div>
        </div>

        <div className="footer-bottom">
          <p>COPYRIGHT© 2026 <strong>PASOS AL ÉXITO 360</strong> | DISEÑADO Y DESARROLLADO POR <strong>PASOS AL ÉXITO</strong>.</p>
        </div>
      </footer>
    </div>
  );
}
